export const state = {
  // JHR: 'Johor',
  // KTN: 'Kelantan',
  // MLK: 'Malacca',
  // PHG: 'Pahang',
  // TRG: 'Terengganu',
  PNG: 'Penang',
  KDH: 'Kedah'
  // PRK: 'Perak'
}

export const STATE_OPTIONS = Object.values(state)
